import React from 'react';
import { connect } from 'react-redux';
import CurrentWebinars from 'containers/Dashboard/CurrentWebinars/CurrentWebinars'
import UpcomingWebinars from 'containers/Dashboard/UpcomingWebinars/UpcomingWebinars'
import PreviousWebinars from 'containers/Dashboard/PreviousWebinars/PreviousWebinars'
import ZoomInfo from 'containers/Dashboard/ZoomInfo';
import actions from 'actions';
import constants from 'constants';
import DisciplineTagSelect from 'containers/Input/DisciplineTagSelect';

const ALL = 'All';

const {
  loadUpcomingWebinarsSaga,
  loadCurrentWebinarsSaga,
  loadPreviousWebinarsSaga,
  loadSubscriptionsSaga,
  cleanWebinars,
  setProfileConfirmation,
  reloadDashboardWebinars,
  loadSponsorsSuggestionsSaga
} = actions;

const { UPCOMING_WEBINARS, CURRENT_WEBINARS, PREVIOUS_WEBINARS } = constants;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      webinars: [1, 2, 3],
      page: {
        upcoming: 1,
        current: 1,
        previous: 1
      },
      active: '',
      sponsor: ALL,
      disciplines: []
    };
  }

  componentWillMount() {
    const params = this.webinarParams();
    this.props.loadSponsorsSuggestions();
    this.props.loadUpcomingWebinars(this.state.page.upcoming, params);
    this.props.loadCurrentWebinars(this.state.page.current, params);
    this.props.loadPreviousWebinars(this.state.page.previous, params);
    this.setReloadInterval();
  }

  componentWillUnmount() {
    this.props.cleanWebinars();
    this.clearReloadInterval();
  }

  reloadWebinars = () => {
    const params = this.webinarParams();
    this.props.reloadDashboardWebinars(params);
  }

  webinarParams = () => {
    const { sponsor } = this.props;
    const { disciplines } = this.state;
    const filterSponsor = this.state.sponsor;

    if (sponsor) {
      return { sponsor_id: sponsor.id }
    }

    if (filterSponsor && filterSponsor !== ALL) {
      return { sponsor_id: filterSponsor }
    }

    if (disciplines) {
      return { disciplines: disciplines }
    }
  }

  setReloadInterval = () => {
    this.reloadInterval = setInterval(() => {
      this.reloadWebinars();
    }, 20000);
  }

  clearReloadInterval = () => {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  }

  nextPage = webinarType => {
    const params = this.webinarParams();
    switch (webinarType) {
      case UPCOMING_WEBINARS:
        this.setState(
          {
            page: { ...this.state.page, upcoming: this.state.page.upcoming + 1 }
          },
          () => this.props.loadUpcomingWebinars(this.state.page.upcoming, params)
        );
        break;
      case CURRENT_WEBINARS:
        this.setState(
          {
            page: { ...this.state.page, current: this.state.page.current + 1 }
          },
          () => this.props.loadCurrentWebinars(this.state.page.current, params)
        );
        break;
      case PREVIOUS_WEBINARS:
        this.setState(
          {
            page: { ...this.state.page, previous: this.state.page.previous + 1 }
          },
          () => this.props.loadPreviousWebinars(this.state.page.previous, params)
        );
        break;
    }
  };

  hideProfileConfirmation = () => {
    this.props.hideProfileConfirmation();
  }

  changeActiveLink = val =>
    this.setState({
      active: val
    });

  sponsorSuggestions = () => {
    const { sponsorOptions } = this.props;
    return [...sponsorOptions, { label: ALL, value: ALL }];
  }

  onFilterChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      page: {
        upcoming: 1,
        current: 1,
        previous: 1
      }
    }, this.reloadWebinars);
  }

  onDisciplinesChange = (disciplines) => {
    this.setState({ disciplines: (disciplines || []).map(discipline => discipline.value),
      page: {
        upcoming: 1,
        current: 1,
        previous: 1
      }}, this.reloadWebinars);
  }


  renderFilters = () => {
    if (this.props.sponsor) {
      return null;
    }

    return <div className="section_webinars_sponsors_filter">
      <DisciplineTagSelect
        onChange={this.onDisciplinesChange}
        value={this.state.disciplines}
      />
    </div>
  }

  render() {
    return (
      <main className="site--width">
        <ZoomInfo />
        <div className="section_webinars">
          <h2 className="main_title">WEBINARS</h2>
          <ul className="section_webinars_list tabs">
            <li className="section_webinars_list_item tab">
              <a
                className={this.state.active == 'current' && 'active'}
                href="#current"
                onClick={() => this.changeActiveLink('current')}
              >
                CURRENT {this.props.current.count ? `(${this.props.current.count})` : '(0)'}
              </a>
            </li>
            <li className="section_webinars_list_item tab">
              <a
                href="#upcoming"
                onClick={() => this.changeActiveLink('upcoming')}
                className={this.state.active == 'upcoming' && 'active'}
              >
                UPCOMING {this.props.upcoming.count ? `(${this.props.upcoming.count})` : '(0)'}
              </a>
            </li>
            <li className="section_webinars_list_item tab">
              <a
                href="#previous"
                onClick={() => this.changeActiveLink('previous')}
                className={this.state.active == 'previous' && 'active'}
              >
                RECORDED {this.props.previous.count ? `(${this.props.previous.count})` : '(0)'}
              </a>
            </li>
          </ul>
          {this.renderFilters()}
        </div>
        <CurrentWebinars
          webinars={this.props.current.values}
          nextPage={() => this.nextPage(CURRENT_WEBINARS)}
          page={this.state.page.current}
          count={this.props.current.count}
        />
        <UpcomingWebinars
          webinars={this.props.upcoming.values}
          nextPage={() => this.nextPage(UPCOMING_WEBINARS)}
          page={this.state.page.upcoming}
          count={this.props.upcoming.count}
        />
        <PreviousWebinars
          webinars={this.props.previous.values}
          nextPage={() => this.nextPage(PREVIOUS_WEBINARS)}
          page={this.state.page.previous}
          count={this.props.previous.count}
          sponsor={this.state.sponsor}
          sponsors={this.sponsorSuggestions()}
          onFilterChange = {this.onFilterChange}
        />
      </main>
    );
  }
}

const mapStateToProps = state => ({
  upcoming: state.webinars[UPCOMING_WEBINARS],
  current: state.webinars[CURRENT_WEBINARS],
  previous: state.webinars[PREVIOUS_WEBINARS],
  sponsorOptions: state.suggestions.sponsor.values
});

const mapDispatchToProps = dispatch => ({
  loadCurrentWebinars: (page, params) => dispatch(loadCurrentWebinarsSaga(page, params)),
  loadUpcomingWebinars: (page, params) => dispatch(loadUpcomingWebinarsSaga(page, params)),
  loadPreviousWebinars: (page, params) => dispatch(loadPreviousWebinarsSaga(page, params)),
  loadSubscriptions: () => dispatch(loadSubscriptionsSaga()),
  cleanWebinars: () => dispatch(cleanWebinars()),
  hideProfileConfirmation: () => dispatch(setProfileConfirmation(false)),
  reloadDashboardWebinars: (params) => dispatch(reloadDashboardWebinars(params)),
  loadSponsorsSuggestions: () => dispatch(loadSponsorsSuggestionsSaga())
});
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/Dashboard.js
 **/